var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sleep } from './Sleep';
import { RetryFailError } from '../errorTypes/RetryFailError';
const DEFAULT_ATTEMPTS = 1;
const DEFAULT_BASE = 1;
const JITTER_RATE = 0.5;
/**
 * Converts error instance into json object
 * @param error error instance
 * @returns json representation of the error instance
 */
const convertErrorToJson = (error) => {
    return JSON.parse(JSON.stringify(error, Object.getOwnPropertyNames(error)));
};
/**
 * A simple retry implementation to be retry failed function calls
 * @param retryOptions options to customize retry behavior
 * @param functionToBeRetried a function/async/Promise to be retried
 * @param functionParameters parameters of the functionToBeRetried
 * @returns IRetryResponse which includes the return value of the functionToBeRetried and the number of attempts in total
 * @throws RetryFailError which includes a stringified list of errors of all attempts and the number of attempts
 */
const callWithRetry = (retryOptions, functionToBeRetried, ...functionParameters) => __awaiter(void 0, void 0, void 0, function* () {
    const errorHistory = [];
    let attemptCount = 0;
    const maximumAttempts = retryOptions.attempts || DEFAULT_ATTEMPTS;
    const base = retryOptions.base || DEFAULT_BASE;
    const delay = retryOptions.delay;
    const jitterRate = retryOptions.jitter ? JITTER_RATE : 0;
    const doAsyncAttempt = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            return yield functionToBeRetried(...functionParameters);
        }
        catch (error) {
            errorHistory.push(error);
            attemptCount++;
            if (attemptCount < maximumAttempts) {
                const jitter = 1 + jitterRate * Math.random();
                const exponentialDelayWithJitter = Math.round(delay * Math.pow(base, attemptCount - 1) * jitter);
                yield sleep(exponentialDelayWithJitter);
                return yield doAsyncAttempt();
            }
            else {
                const errorHistoryObjects = errorHistory.map((errorEntry) => {
                    return errorEntry instanceof Error
                        ? convertErrorToJson(errorEntry)
                        : errorEntry;
                });
                const stringifiedErrorHistory = JSON.stringify(errorHistoryObjects);
                throw new RetryFailError(stringifiedErrorHistory, attemptCount, error);
            }
        }
    });
    const retryResult = {
        data: yield doAsyncAttempt(),
        attempts: attemptCount + 1, // attemptCount doesn't count the final successful try, so + 1
    };
    return retryResult;
});
export { callWithRetry };
//# sourceMappingURL=Retry.js.map